import script from "./Personal.vue?vue&type=script&setup=true&lang=js"
export * from "./Personal.vue?vue&type=script&setup=true&lang=js"

import "./Personal.vue?vue&type=style&index=0&id=5843c20e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5843c20e"]])

export default __exports__